import { combineReducers } from "redux";
import { DESTROY_SESSION } from "../actions/type";
import auth from "./auth";
import user from "./user";
import category from "./category";
import store from "./store";
import chats from "./chats";
import banner from "./banner";

const appReducer = combineReducers({
    auth,
    user,
    category,
    store,
    chats,
    banner
  });
  
  const rootReducer = (state, action) => {
    // // Clear all data in redux store to initial.
    if (action.type === DESTROY_SESSION) {
      state = undefined;
      action = { type: '@@INIT' }
    }
    return appReducer(state, action);
  };
  export default rootReducer;